import { defaultTheme } from "@cobee/cobee-ui";

const styles = {
  row: {
    display: "flex",
  },
  labelStyle: {
    marginRight: defaultTheme.spacing(1),
    color: defaultTheme.palette.grey[700],
  },
};

export default styles;
